import { KoncentroBaseModel } from './koncentro-base.model';

export class ServiceType extends KoncentroBaseModel {
  public id: number;
  public name:string;
  public description:string;
}



// WEBPACK FOOTER //
// ./src/app/models/service-type.model.ts